// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 94px;
  background-color: #FFFFFF;
}
.wrapper .corner {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 38px;
}

ion-checkbox {
  --background: transparent;
}

.header_block {
  margin-top: 20px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header_block ion-icon {
  height: 44px;
  width: 44px;
}

.logo {
  max-height: 120px;
  height: 40%;
  margin: auto;
}

.title {
  font-family: AppFontBold;
  font-size: 20px;
  line-height: 24.8px;
  text-align: center;
  margin-bottom: 18px;
}

.info {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16.8px;
  text-align: center;
  color: #000;
  margin-bottom: 25px;
}
.info strong {
  font-family: AppFontBold;
}

.warning-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #1E1E1C;
  margin-bottom: 25px;
}

.policy-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #1E1E1C;
  margin-bottom: 25px;
}

ul {
  list-style-type: none;
  padding: 0px 20px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  text-decoration: none;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
}
li .wrapper-inner {
  background: white;
  width: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li .wrapper-inner .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .wrapper-inner .info_block p {
  padding: 0px 10px;
  color: var(--ion-color-primary);
  font-family: AppFont, sans-serif;
}
li .wrapper-inner .info_block ion-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
li .wrapper-inner .circle {
  width: 30px;
  height: 30px;
  content: " ";
  border: 2px solid var(--ion-color-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
li .wrapper-inner .circle .cirle_inner {
  width: 22px;
  height: 22px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .wrapper-inner .circle .cirle_inner.selected {
  background: var(--ion-color-secondary);
  border-radius: 50;
  transition: ease-in-out 0.3s;
}

.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  font-family: AppFontBold, sans-serif;
  width: 100%;
  font-size: 16px;
}

.block-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 0px;
  cursor: pointer;
}
.block-checkbox ion-checkbox {
  --checkmark-color: #fff;
  pointer-events: none;
  margin-right: 12px;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .block-checkbox ion-checkbox {
    margin-top: -1px;
  }
}

.wrapper-block {
  padding: 0px 20px 20px;
}

.age-info {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16.8px;
  color: #1E1E1C;
  text-align: left;
}

.btn {
  width: 100%;
  height: 54px;
  background: var(--ion-color-primary);
  border-radius: var(--radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.3s ease;
}
@media (min-width: 991px) {
  .btn {
    height: 67px;
  }
}
.btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn span {
  font-family: AppFont, sans-serif;
  color: #000;
  font-size: 16px;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/confirm-year-dialog/confirm-year-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;AADF;AAGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAIE;EACE,YAAA;EACA,WAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAHF;AAKE;EACE,wBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,uDAAA;AAJF;AAME;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;AAMI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAJN;AAMM;EACE,iBAAA;EACA,+BAAA;EACA,gCAAA;AAJR;AAOM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALR;AASI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAPR;AASQ;EACE,sCAAA;EACA,iBAAA;EACA,4BAAA;AAPV;;AAcA;EACE,iBAAA;AAXF;AAaE;EACE,WAAA;EACA,WAAA;AAXJ;;AAeA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAZF;AAcE;EACE,oCAAA;EACA,WAAA;EACA,eAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AAbF;AAeE;EACE,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAbJ;ACtKE;ED+KA;IAOI,gBAAA;EAZJ;AACF;;AAgBA;EACE,sBAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAbF;ACzME;ED6MF;IAYI,YAAA;EAZF;AACF;AAcE;EACE,YAAA;EACA,mBAAA;AAZJ;AAeE;EACE,gCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAbJ","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  padding-bottom: 94px;\n  background-color: #FFFFFF;\n\n  .corner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 38px;\n  }\n}\n\nion-checkbox {\n  --background: transparent;\n}\n\n.header_block {\n  margin-top: 20px;\n  margin-bottom: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n  }\n}\n\n.logo {\n  max-height: 120px;\n  height: 40%;\n  margin: auto;\n}\n\n.title {\n  font-family: AppFontBold;\n  font-size: 20px;\n  line-height: 24.8px;\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n.info {\n  font-family: AppFont;\n  font-size: 14px;\n  line-height: 16.8px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 25px;\n\n  strong {\n    font-family: AppFontBold;\n  }\n}\n\n.warning-text {\n  font-family: AppFont;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  color: #1E1E1C;\n  margin-bottom: 25px;\n}\n\n.policy-text {\n  font-family: AppFont;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  color: #1E1E1C;\n  margin-bottom: 25px;\n}\n\nul {\n  list-style-type: none;\n  padding: 0px 20px;\n}\n\nli {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 10px;\n  text-decoration: none;\n  box-shadow: 0px 4px 10px 0px #00000008;\n\n  .wrapper-inner {\n    background: white;\n    width: 100%;\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .info_block {\n      border-radius: 20px;\n      display: flex;\n      align-items: center;\n\n      p {\n        padding: 0px 10px;\n        color: var(--ion-color-primary);\n        font-family: AppFont, sans-serif;\n      }\n\n      ion-img {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        overflow: hidden;\n      }\n    }\n\n    .circle {\n      width: 30px;\n      height: 30px;\n      content: ' ';\n      border: 2px solid var(--ion-color-secondary);\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .cirle_inner {\n        width: 22px;\n        height: 22px;\n        content: ' ';\n        background: transparent;\n        border-radius: 50%;\n\n        &.selected {\n          background: var(--ion-color-secondary);\n          border-radius: 50;\n          transition: ease-in-out 0.3s;\n        }\n      }\n    }\n  }\n}\n\n.line-border {\n  padding: 0px 20px;\n\n  ion-icon {\n    fill: white;\n    width: 100%;\n  }\n}\n\n.footer-item {\n  position: fixed;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n\n  ion-button {\n    font-family: AppFontBold, sans-serif;\n    width: 100%;\n    font-size: 16px;\n  }\n}\n\n.block-checkbox {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px 0px;\n  cursor: pointer;\n\n  ion-checkbox {\n    --checkmark-color: #fff;\n    pointer-events: none;\n    margin-right: 12px;\n    flex-shrink: 0;\n\n    @include mobile {\n      margin-top: -1px;\n    }\n  }\n}\n\n.wrapper-block {\n  padding: 0px 20px 20px;\n}\n\n.age-info {\n  font-family: AppFont;\n  font-size: 14px;\n  line-height: 16.8px;\n  color: #1E1E1C;\n  text-align: left;\n}\n\n.btn {\n  width: 100%;\n  height: 54px;\n  background: var(--ion-color-primary);\n  border-radius: var(--radius-default);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n\n  @include desktop {\n    height: 67px;\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  span {\n    font-family: AppFont, sans-serif;\n    color: #000;\n    font-size: 16px;\n    line-height: 19.2px;\n    letter-spacing: 0.01em;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
